<template>
  <div class="subscription-inactive">
    <div class="inactive-container">
      <div class="inactive-icon">
        <i class="fas fa-lock"></i>
      </div>
      <h1 class="inactive-title">Suscripción Inactiva</h1>
      <p class="inactive-message">
        Tu suscripción no está activa. Para continuar usando el sistema, necesitas validar el pago pendiente.
      </p>
      <div class="inactive-actions">
        <router-link to="/iniciar-sesion" class="btn-cerrarSesion">
          <i class="fas fa-sign-out-alt me-2"></i>
          Cerrar Sesión
        </router-link>
      </div>
      <div class="inactive-info">
        <p>Si ya realizaste el pago, contacta al administrador para que valide tu transacción.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubscriptionInactive'
}
</script>

<style scoped>
.subscription-inactive {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.inactive-container {
  background: white;
  border-radius: 12px;
  padding: 40px;
  text-align: center;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  width: 100%;
}

.inactive-icon {
  font-size: 4rem;
  color: #dc3545;
  margin-bottom: 20px;
}

.inactive-title {
  color: #333;
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 16px;
}

.inactive-message {
  color: #666;
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 30px;
}

.inactive-actions {
  margin-bottom: 30px;
}

.btn-cerrarSesion {
  background: #dc3545;
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  font-weight: 500;
  transition: background-color 0.3s ease;
}

.btn-cerrarSesion:hover {
  background: #c82333;
  color: white;
  text-decoration: none;
}

.inactive-info {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  border-left: 4px solid #ffc107;
}

.inactive-info p {
  margin: 0;
  color: #666;
  font-size: 0.95rem;
}
</style>


